import * as React from 'react';
import classNames from 'classnames';

import IMPComponent from '../interfaces/IMPComponent';
import { ISvgIconProps } from '../SvgIcon';
import SvgIcon from '../SvgIcon';
import posed from 'react-pose';

type ICalendarNavButtonProps = IMPComponent & ISvgIconProps & React.HTMLProps<HTMLButtonElement>;

const Box = posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1,
  },
  hover: {
    scale: 1.05,
    transition: { type: 'spring', stiffness: 200 },
  },
});

const CalendarNavButton: React.FunctionComponent<ICalendarNavButtonProps> = ({
  className,
  style,
  iconName,
  iconWidth,
  iconHeight,
  ...props
}) => {
  const cn = classNames('Calendar-navButton', className);

  return (
    <Box>
      <button type={'button' as any} className={cn} style={style} {...props}>
        <SvgIcon iconName={iconName} iconWidth={iconWidth} iconHeight={iconHeight} />
      </button>
    </Box>
  );
};

CalendarNavButton.defaultProps = {
  iconWidth: 26,
  iconHeight: 26,
};

export default CalendarNavButton;



// WEBPACK FOOTER //
// ./src/components/Calendar/CalendarNavButton.tsx